import { render, staticRenderFns } from "./person-complete-card.vue?vue&type=template&id=5f3c42a5&"
import script from "./person-complete-card.vue?vue&type=script&lang=js&"
export * from "./person-complete-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports